import React, { Fragment, useState } from "react";
import { bool, func, object } from "prop-types";
import { connect } from "react-redux";
import FileDropzone from "../../common/FileDropzone/FileDropzone";
import { Button } from "../../common";
import Popup from "../../common/Popup/Popup";
import { updateUserInProfileSilent } from "../../redux/actions";
import history from "../../history";

import * as style from "./styles.module.scss";

const ProfileImage = ({
  updateProfile,
  appData,
  isOpen,
  setOpen,
  customCancelHandler,
  popupOnMobile = true,
}) => {
  const [isProfileImageValid, setProfileImageValid] = useState(true);
  const [file, setFile] = useState(null);

  const cancelHandler = () => {
    if (customCancelHandler) {
      customCancelHandler();
    }
    setOpen(false);
    setFile(appData.profileImage && appData.profileImage.previewContent);
  };
  const saveProfileImage = () => {
    const { candidateRef, emailAddress, permissions } = appData;
    const updatedUserData = {
      candidateRef,
      emailAddress,
      profileImageData: file,
      isPecan: permissions.isPecan,
    };
    updateProfile(candidateRef, updatedUserData);
    history.push("/profile");
  };

  const imageUploadOptions = {
    maxWidth: 1000,
    maxHeight: 1000,
    contain: false,
  };

  const fragment = (uploadText = "Upload") => (
    <Fragment>
      <div className={style.dropzone}>
        <FileDropzone
          dropFileMsg="Drop your profile image here"
          fileTypeHint="This should be a JPEG or PNG file."
          acceptedFileTypes=".jpg,.jpeg,.png"
          handleChange={(fileStateName, value) => {
            setFile(value);
          }}
          fileStateName="selfieFile"
          fileParsedToString={file}
          handleInvalidType={() => {
            setProfileImageValid(true);
          }}
          isFileValid={isProfileImageValid}
          wrongFileTypeHint="Your image needs to be provided as a JPEG or PNG file."
          fileCategory="image"
          width="unset"
          imageMaxWidth="100%"
          imageUploadOptions={imageUploadOptions}
          url={appData.profileImage && appData.profileImage.url}
        />
      </div>
      <div className="d-flex justify-content-end mt-2 mt-sm-0 flex-sm-row flex-column-reverse">
        <Button
          classes="btn btn-outline-dark col-12 col-sm-2 mt-1"
          onClick={cancelHandler}
          styles={{ minWidth: "175px" }}
        >
          Back to My Account
        </Button>
        <Button
          classes="btn btn-primary mt-sm-1 ml-sm-2 col-12 col-sm-5 col-md-4 col-lg-2"
          onClick={saveProfileImage}
          disabled={
            !file ||
            (appData.profileImage &&
              file === appData.profileImage.previewContent)
          }
        >
          {uploadText}
        </Button>
      </div>
    </Fragment>
  );

  return (
    <Fragment>
      <div className="d-none d-lg-block">
        <Popup
          isOpen={isOpen}
          handleCloseClick={cancelHandler}
          title="Update your profile image"
          padding="16px"
          overNav={true}
        >
          {fragment()}
        </Popup>
      </div>
      <div className="d-lg-none">
        {popupOnMobile ? (
          <Popup
            isOpen={isOpen}
            handleCloseClick={cancelHandler}
            title="Update your profile image"
            padding="16px"
            overNav={true}
          >
            {fragment()}
          </Popup>
        ) : (
          isOpen && fragment("Upload profile image")
        )}
      </div>
    </Fragment>
  );
};

ProfileImage.propTypes = {
  appData: object,
  updateProfile: func,
  isOpen: bool.isRequired,
  setOpen: func.isRequired,
  customCancelHandler: func,
  popupOnMobile: bool,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const mapDispatchToProps = {
  updateProfile: updateUserInProfileSilent,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(ProfileImage);
